import { render, staticRenderFns } from "./BannerSlide.vue?vue&type=template&id=0cc1a2b7&scoped=true&"
import script from "./BannerSlide.vue?vue&type=script&lang=js&"
export * from "./BannerSlide.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlide.vue?vue&type=style&index=0&id=0cc1a2b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1a2b7",
  null
  
)

export default component.exports